const Config={
    "name" : "FENDI",
    "logo" : "logo-fendi.png",
    "logoMini" : "icon/logo-3.png",
    "copy" : "@2020 FENDI",
    "needAddress":false
}
export default Config



// WEBPACK FOOTER //
// ./src/utils/global.js